<template>
  <div
    v-if="selectedJobId"
    class="boss-pickup-wrap"
  >
    <div class="boss-pickup-form">
      <!-- ▼本日のおすすめ見出し -->
      <div class="boss-pickup-headline">
        <h2 class="boss-pickup-title">
          <span class="boss-icon boss-icon-pickup" />
          <span>本日のおすすめ</span>
        </h2>
        <!-- ▼本日のおすすめ求人プルダウン -->
        <div class="boss-pulldown-container boss-published margin-bottom-0">
          <label
            class="boss-pulldown-menu"
            for="boss-published-item"
          >
            <select
              id="boss-published-item"
              v-model="selectedJobId"
              class="boss-pulldown-menu-item"
              data-test="job-pulldown"
              @change="onChangeJob"
            >
              <option
                v-for="(job,key) in publishedContract.jobs.filter(job => job.isPublished)"
                :key="key"
                :data-test="'job-' + key"
                :value="job.id"
              >
                求人ID: {{ job.id }} {{ job.managementName }}
              </option>
            </select>
          </label>
        </div>
        <!-- ▲本日のおすすめ求人プルダウン -->
      </div>
      <!-- ▲本日のおすすめ見出し -->
      <div class="boss-form-container">
        <div class="boss-layout boss-layout-vertical boss-layout-fill">
          <div>
            <div class="boss-batch-container clearfix padding-top-0">
              <scout-members-bulk-register
                :job-id="selectedJobId"
                :contract-id="publishedContract.id"
                :member-objects="checkedMemberObjects"
                @fetch="fetchRecommended(publishedContract.id, selectedJobId)"
                @clearCheckedMembers="clearCheckedMembers"
              />
            </div>
          </div>
          <div>
            <div class="boss-resumecard-list">
              <template v-for="(memberObject, i) in infinityMemberObjects">
                <scout-resume-card
                  v-if="!memberObject.member.isScoutExcluded"
                  :key="i"
                  :member-object="memberObject"
                  :checked="checkedMemberIds"
                  :contract-id="publishedContract.id"
                  :job-id="selectedJobId"
                  :shows-scout-button="isSendScout"
                  @checked="checked"
                  @change="changed"
                  @spliceCheckedMember="spliceCheckedMember"
                />
              </template>
            </div>
          </div>
          <infinity-scroll
            :objects="memberObjects"
            :infinity-objects.sync="infinityMemberObjects"
            :display-count="displayCount"
            :no-results-label="noResultsLabel"
          />
          <scout-recommended-footer :show-recommended-less="showRecommendedLess" />
          <selected-counter :checked-count="checkedMemberIds.length" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScoutResumeCard from '@/components/organisms/ScoutResumeCard'
import ScoutMembersBulkRegister from '@/components/molecules/ScoutMembersBulkRegister'
import ScoutRecommendedFooter from '@/components/atoms/ScoutRecommendedFooter'
import SelectedCounter from '@/components/molecules/SelectedCounter'
import InfinityScroll from '@/components/atoms/InfinityScroll'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import Indicator from '@/lib/indicator'

export default {
  components: {
    ScoutResumeCard,
    ScoutMembersBulkRegister,
    ScoutRecommendedFooter,
    InfinityScroll,
    SelectedCounter
  },
  data () {
    return {
      memberObjects: [],
      checkedMemberIds: [],
      infinityMemberObjects: [],
      selectedJobId: null
    }
  },
  computed: {
    noResultsLabel () {
      if (!Indicator.getLoadingStatus()) {
        return 'おすすめ会員がいません。'
      }
      return ''
    },
    checkedMemberObjects () {
      return this.checkedMemberIds.map(id => _(this.memberObjects).find({ id: id }))
    },
    publishedContract () {
      return _.head(this.publishedContracts)
    },
    ...mapGetters('contracts', [
      'publishedContracts'
    ]),
    ...mapGetters([
      'isSendScout'
    ]),
    showRecommendedLess () {
      return this.displayCount <= 20 && !Indicator.getLoadingStatus()
    },
    displayCount () {
      return this.memberObjects.filter(memberObject => !memberObject.member.isScoutExcluded).length
    }
  },
  watch: {
    publishedContracts: {
      handler (val) {
        // 有効な契約がない場合にエラーになるため
        if (val.length) {
          const contract = _.head(val)
          const publishedJobs = contract.jobs.filter(job => job.isPublished)
          if (!publishedJobs.length) return // 掲載求人がない場合は終了

          const firstJobWithRecommend = _.head(publishedJobs.filter(job => job.hasRecommendUser))
          if (firstJobWithRecommend) {
            this.$set(this, 'selectedJobId', Number(firstJobWithRecommend.id))
            this.fetchRecommended(contract.id, firstJobWithRecommend.id)
          } else {
            this.$set(this, 'selectedJobId', Number(_.head(publishedJobs).id))
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    checked (id) {
      if (!_.includes(this.checkedMemberIds, id)) {
        this.checkedMemberIds.push(id)
      }
    },
    changed (val) {
      if (_.includes(this.checkedMemberIds, val)) {
        this.checkedMemberIds.splice(this.checkedMemberIds.findIndex(n => n === val), 1)
      } else {
        this.checkedMemberIds.push(val)
      }
    },
    clearCheckedMembers () {
      this.$set(this, 'checkedMemberIds', [])
    },
    fetchRecommended (contractId, jobId) {
      Indicator.emitShow()
      this.$http.secured.get(`/scout/view/scouts/contracts/${contractId}/jobs/${jobId}/recommended_users`)
        .then(response => {
          const members = response.data.map((member) => {
            return {
              id: member.recommendedId,
              member: { ...member, isScoutExcluded: false }
            }
          })
          this.$set(this, 'memberObjects', members)
        }).finally(() => {
          Indicator.emitHide()
        })
    },
    onChangeJob () {
      this.fetchRecommended(this.publishedContract.id, this.selectedJobId)
      this.$set(this, 'checkedMemberIds', [])
    },
    spliceCheckedMember (memberObjectId) {
      this.checkedMemberIds.splice(this.checkedMemberIds.findIndex(id => id === memberObjectId), 1)
    }
  }
}
</script>
